module.exports = __webpack_public_path__ + "assets/06ee6502dd49b2e0604223b939491897.mp3";